import { topshotsAPI } from '../../app/api';

export interface BillingStatusResponse {
  billingStatus: string;
  pricingTier: string | null;
  hasSubscription: boolean;
  hasCustomer: boolean;
  resolvedPricing: {
    monthlyFeeCents: number;
    transactionFeeBps: number;
    transactionFeeFixedCents: number;
    pricingTier: string;
    stripeProductId: string | null;
    isFree: boolean;
  } | null;
}

const billingApi = topshotsAPI.injectEndpoints({
  endpoints: (build) => ({
    getBillingStatus: build.query<BillingStatusResponse, void>({
      query: () => 'stripe-connect/billing',
      providesTags: ['AccountBilling'],
    }),

    setupBilling: build.mutation<
      { checkoutUrl: string },
      { successUrl: string; cancelUrl: string }
    >({
      query: (body) => ({
        url: 'stripe-connect/billing/setup',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['AccountBilling'],
    }),

    createBillingPortal: build.mutation<
      { portalUrl: string },
      { returnUrl: string }
    >({
      query: (body) => ({
        url: 'stripe-connect/billing/portal',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const {
  useGetBillingStatusQuery,
  useSetupBillingMutation,
  useCreateBillingPortalMutation,
} = billingApi;
